/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_RecentInputs */

const en_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Recent`)
};

const fr_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets récents`)
};

const de_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt geöffnet`)
};

const it_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri recenti`)
};

const ru_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть недавние`)
};

const es_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir reciente`)
};

const zh_cn2_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近打开`)
};

const ja_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近開いた`)
};

const hi_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल ही वाला खोलें`)
};

const pt_pt2_open_recent = /** @type {(inputs: Open_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir recentes`)
};

/**
* | output |
* | --- |
* | "Open Recent" |
*
* @param {Open_RecentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_recent = /** @type {((inputs?: Open_RecentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_RecentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_open_recent(inputs)
	if (locale === "de") return de_open_recent(inputs)
	if (locale === "it") return it_open_recent(inputs)
	if (locale === "ru") return ru_open_recent(inputs)
	if (locale === "es") return es_open_recent(inputs)
	if (locale === "zh-CN") return zh_cn2_open_recent(inputs)
	if (locale === "ja") return ja_open_recent(inputs)
	if (locale === "hi") return hi_open_recent(inputs)
	if (locale === "pt-PT") return pt_pt2_open_recent(inputs)
	return en_open_recent(inputs)
});